
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"4","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 2.333v.007M2 7v.007m0 4.66v.006M2 3a.667.667 0 110-1.333A.667.667 0 012 3zm0 4.667a.667.667 0 110-1.334.667.667 0 010 1.334zm0 4.666A.667.667 0 112 11a.667.667 0 010 1.333z","stroke":"#AAA","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    